export const JpegIcon = (props) => (
  <svg
    className={props.className}
    width="46"
    height="57"
    viewBox="0 0 46 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="42.4909"
      height="57"
      rx="2.5"
      fill="#4187F5"
      fillOpacity="0.3"
    />
    <rect
      x="4.59375"
      y="19.6909"
      width="40.5909"
      height="14.6127"
      rx="2.5"
      fill="#4187F5"
    />
    <path
      d="M15.523 32.0126C15.217 32.0126 14.9761 31.9687 14.8003 31.8808V31.1728C15.0315 31.2379 15.2723 31.2704 15.523 31.2704C15.8453 31.2704 16.0894 31.1728 16.2554 30.9775C16.4247 30.7821 16.5093 30.5006 16.5093 30.1327V22.9941H17.3394V30.0644C17.3394 30.6829 17.1831 31.1614 16.8706 31.4999C16.5581 31.8417 16.1089 32.0126 15.523 32.0126ZM23.7652 25.0741C23.7652 25.7968 23.5178 26.3534 23.023 26.7441C22.5315 27.1314 21.8267 27.3251 20.9087 27.3251H20.0689V30.1327H19.2388V22.9941H21.0894C22.8733 22.9941 23.7652 23.6874 23.7652 25.0741ZM20.0689 26.6122H20.816C21.5516 26.6122 22.0839 26.4934 22.4126 26.2558C22.7414 26.0181 22.9058 25.6373 22.9058 25.1132C22.9058 24.6412 22.7512 24.2896 22.4419 24.0585C22.1327 23.8274 21.6509 23.7118 20.9966 23.7118H20.0689V26.6122ZM29.2437 30.1327H25.2642V22.9941H29.2437V23.7314H26.0943V26.0312H29.0533V26.7636H26.0943V29.3905H29.2437V30.1327ZM33.9703 26.3925H36.397V29.8642C36.0194 29.9846 35.6353 30.0758 35.2447 30.1376C34.854 30.1995 34.4016 30.2304 33.8872 30.2304C32.8065 30.2304 31.965 29.9097 31.3628 29.2685C30.7606 28.6239 30.4595 27.7222 30.4595 26.5634C30.4595 25.8212 30.6076 25.1718 30.9039 24.6152C31.2033 24.0553 31.633 23.6288 32.1929 23.3359C32.7528 23.0396 33.4087 22.8915 34.1607 22.8915C34.9224 22.8915 35.632 23.0315 36.2896 23.3114L35.9673 24.0439C35.3228 23.7704 34.7027 23.6337 34.107 23.6337C33.2378 23.6337 32.5591 23.8925 32.0708 24.4101C31.5826 24.9277 31.3384 25.6454 31.3384 26.5634C31.3384 27.5269 31.5728 28.2577 32.0415 28.7558C32.5136 29.2538 33.2053 29.5028 34.1167 29.5028C34.6115 29.5028 35.0949 29.4459 35.5669 29.3319V27.1347H33.9703V26.3925Z"
      fill="white"
    />
  </svg>
);
